import CustomRichText from '../CustomRichText';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import { ReactNode } from 'react';

export interface BlockHeaderProps {
  title: ReactNode | SerializedEditorState;
  subtitle?: ReactNode | SerializedEditorState;
}

export default function BlockHeader({ title, subtitle }: BlockHeaderProps) {
  return (
    <div data-meta="BlockHeader" className="container max-w-7xl mx-auto py-6 sm:py-4">
      <div className="mx-auto text-center">
        <div className="text-white">
          <CustomRichText
            data={title}
            tag="div"
            className="text-3xl font-bold tracking-tight text-white sm:text-6xl mb-4 sm:mb-8"
          />
        </div>

        {subtitle && (
          <div className="text-white">
            <CustomRichText
              data={subtitle}
              tag="div"
              className="mt-6 text-base lg:text-lg md:leading-6 lg:leading-8 text-white px-4"
            />
          </div>
        )}
      </div>
    </div>
  );
}
